import styles from './MainMenu.module.css'
import {useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    ActionMessageInt,
    ReduxStateInt, setDomainPreference,
    setMainMenuId,
    setSlider,
    setTfFilter,
    setXFilterValue
} from "../Reducer/GlobalReducer";
import {Subscription} from "rxjs";
import useApiQuery from "../ApiQuery/UseApiQuery";
function MainMenu()
{
    const [showShortMenu, setShowShortMenu] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mainMenuId = useSelector((state: ReduxStateInt) => {
        return state.activeMainMenuPad
    })
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )
    const xfFilter = useSelector((state:ReduxStateInt)  => {return state.xFilter} )

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const subscriber = useRef<Subscription>()
    const prefDomain = useSelector((state:ReduxStateInt)  => {return state.prefDomain})



    const [mainMenu, setMainMenu] = useState( [
        {
            type:0,
            visible: true,
            text:"Главная",
            id:0,
            sub:[],
            logo: <i className='bx bx-home'></i>,
            active: mainMenuId === 0,
            path: "/"
        },
        {
            type:0,
            visible: true,
            text:"О нас",
            id:3,
            sub:[],
            logo: <i className='bx bx-detail'></i>,
            active: mainMenuId === 3,
            path: "/menu/choose"

        },

        {
            type:0,
            visible: true,
            text:"Доставка",
            id:1,
            sub:[],
            logo: <i className='bx bxs-truck'></i>,
            active: mainMenuId === 1,
            path: "/menu/delivery"
        },
        {
            type:0,
            visible: true,
            text:"Оплата",
            id:2,
            sub:[],
            logo: <i className='bx bx-wallet'></i>,
            active: mainMenuId === 2,
            path: "/menu/payment"
        },
        /*        {
            type:0,
            visible: true,
            text:"Гарантии",
            id:4,
            sub:[],
            logo: <i className='bx bx-receipt'></i>,
            active: mainMenuId === 4,
            path: "/warranty"

        },*/
        {
            type:0,
            visible: true,
            text:"Активация",
            id:5,
            sub:[],
            logo: <i className='bx bx-memory-card'></i>,
            active: mainMenuId === 5,
            path: "/menu/activate"

        },
        {
            type:0,
            visible: true,
            text:"Переход [ MNP ]",
            id:8,
            sub:[],
            logo: <i className='bx bx-transfer'></i>,
            active: mainMenuId === 8,
            path: "/menu/mnp"

        },
        {
            type:0,
            visible: true,
            text:"Контакты",
            id:6,
            sub:[],
            logo: <i className='bx bxs-contact'></i>,
            active: mainMenuId === 6,
            path: "/menu/contact"

        },
        {
            type:0,
            visible: false,
            text:"Корзина",
            id:7,
            sub:[],
            logo: <i className='bx bx-cart-alt'></i>,
            active: mainMenuId === 7,
            path: "/"


        },
    ]);



    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })

    useEffect(()=>{
        activateMenuItem(mainMenuId ? mainMenuId :0)

    },[mainMenuId])


    const messageMake = (message: ActionMessageInt) => {
        //console.log(message)
        if (message?.message?.match(/mainMenu-home/ui) || message?.message?.match(/xFilter-reset/ui)) {
            moveHome()
            return
        }
    }

    const moveHome = () =>{
        //dispatch(sendActionMessage("hello"))
        setShowShortMenu(false)
        dispatch(setSlider({sliderMode:0}));
        dispatch(setTfFilter({...tfFilter,active: false}))
        dispatch(setXFilterValue({...xfFilter,active: false,val:""}))

    }


    const activateMenuItem=(id:number) =>{
        let path = "/"
        const newMenu = mainMenu.map((item)=>{
            if(item.id === id) {item.active = true; path = item.path;}
            else item.active = false;
            return item
        })
        setMainMenu(newMenu);
        dispatch(setSlider({sliderMode:0,}))
        dispatch(setMainMenuId(id))
        //navigate(path)
        switch (id)
        {
            case 0:
                moveHome()
                break
        }
    }
    const buildMenu = ()=>{


        return mainMenu.map((item,idx)=>{
            if(! item?.visible) return null
            const active = item?.active ? [styles.active] : []
            const menuItem = prefDomain?.mainMenuClass ? [styles[prefDomain?.mainMenuClass]] : [styles.defMenu]


            if(item?.logo)
                return (
                    <Link to={item?.path} className={styles.link} key={idx}>
                        <div key={idx+11} className={[styles.menuItem, ...menuItem, ...active].join(' ')} onClick={(e)=>activateMenuItem(item.id)}>
                            {item.logo}
                            <li><div  key={idx+10}>{item.text}</div></li>
                        </div>

                    </Link>

                );

            return(
                <Link to={item?.path} className={styles.link} key={idx}>
                    <div key={idx+11} className={[styles.menuItem, active].join(' ')} onClick={(e)=>activateMenuItem(item.id)}>
                        <li><div  key={idx+10}>{item.text}</div></li>
                    </div>
                </Link>

            );
        })
    }

    return(
        <div className={styles.mainMenu}>
            <div className={[styles.menuContainer, showShortMenu ? styles.active :""].join(' ')}>
                <ul className={styles.menuList}>
                    {buildMenu()}

                </ul>
            </div>
        <div className={styles.menuButton} onClick={()=>setShowShortMenu(! showShortMenu)}><i className='bx bx-menu'></i></div>
        </div>
    );
}
export default MainMenu